import kebabCase from 'lodash/kebabCase'

const getSearchUrl = ({
  query,
  source,
  shopKey,
}: {
  query: string
  shopKey: string
  source?: string
}) => {
  const SearchURLEnum: Record<string, string> = {
    amazon: `/redirect?s=1${source ? `&src=input-${source}` : ''}&link=https://www.amazon.com/s?k=${query}`,
    wayfair: `/redirect?s=1${source ? `&src=input-${source}` : ''}&link=https://www.wayfair.com/keyword.php?keyword=${query}`,
    walmart: `/redirect?s=1${source ? `&src=input-${source}` : ''}&link=https://www.walmart.com/search?q=${query}`,
    bbb: `/redirect?s=1${source ? `&src=input-${source}` : ''}&link=https://www.bedbathandbeyond.com/${kebabCase(query)},/k,/results.html?SearchType=Header`,
  }

  return SearchURLEnum[shopKey]
}

export default getSearchUrl
